export const contentTableConfig = {
  propList: [
    { prop: 'dictName', label: '字典名称', minWidth: '80' },
    { prop: 'dictCode', label: '字典编码', minWidth: '80' },
    { prop: 'description', label: '描述', minWidth: '80' },
    { label: '操作', minWidth: '120', slotName: 'handler'}
    ]
}
